<mat-form-field *ngIf="style == 'field'">
  <mat-label>{{label}}</mat-label>
  <input matInput [formControl]="searchInput" maxlength="100">
  <mat-icon matSuffix>search</mat-icon>
</mat-form-field>

<div class="inline" *ngIf="style == 'inline'">
  <input [formControl]="searchInput" maxlength="100" [placeholder]="label">
  <span class="inline-icon">
    <mat-icon class="icon">search</mat-icon>
  </span>
</div>
